<button class="option-button hover-pointer" (click)="showMenu = !showMenu">
	<icon type="ellipsis-v"></icon>
</button>
<ac-actions-drawer *ngIf="showMenu">
	<ng-container>
		<ac-actions-drawer-item
			[text]="'Analyze' | dcr: 'MB_ACTION_DRAWER_ANALYZE'"
			[subText]="'Analyze in 360' | dcr: 'MB_ACTION_DRAWER_ANALYZE_SUBTEXT'"
			(click)="onRedirectTo360()"
		>
		</ac-actions-drawer-item>
	</ng-container>
	<!-- <ng-container>
		<ac-actions-drawer-item
			[text]="'Generate Report' | dcr: 'MB_ACTION_DRAWER_GENERATE_REPORT'"
			[subText]="'Generate a report for this model' | dcr: 'MB_ACTION_DRAWER_GENERATE_REPORT_SUBTEXT'"
			(click)="onGenerateReportClick()"
		>
		</ac-actions-drawer-item>
	</ng-container> -->
	<ng-container>
		<ac-actions-drawer-item
			[text]="'Customize' | dcr: 'MB_ACTION_DRAWER_CUSTOMIZE'"
			[subText]="'Copy and modify holdings' | dcr: 'MB_ACTION_DRAWER_CUSTOMIZE_SUBTEXT'"
			(click)="onCustomizePortfolio()"
		>
		</ac-actions-drawer-item>
	</ng-container>
	<ng-container>
		<ac-actions-drawer-item
			[text]="'Blend' | dcr: 'MB_ACTION_DRAWER_BLEND'"
			[subText]="'Combine with other portfolios and holdings' | dcr: 'MB_ACTION_DRAWER_BLEND_SUBTEXT'"
			(click)="onBlendPortfolio()"
		>
		</ac-actions-drawer-item>
	</ng-container>
</ac-actions-drawer>
